module.exports = __webpack_public_path__ + "static/media/BhartiK.d8bdfbbd.jpg";